import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=562229ea&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=562229ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562229ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('562229ea')) {
      api.createRecord('562229ea', component.options)
    } else {
      api.reload('562229ea', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=562229ea&scoped=true&", function () {
      api.rerender('562229ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8v8mtGChIa9zX/JS/comp/SearchFilterTokens.vue"
export default component.exports